import React from 'react';
import PropTypes from 'prop-types';

import FieldsetCreateEditContainer from './FieldsetCreateEditContainer';

const propTypes = {
  params: PropTypes.object.isRequired,
};

const groupSKUPage = ({ params }) => (
  <div className={params.page}>
    <FieldsetCreateEditContainer
      page={params.page}
      datasetId={params.datasetId}
      fieldsetId={params.fieldsetId}
    />
  </div>
);

groupSKUPage.propTypes = propTypes;

export default groupSKUPage;
